import React from "react";

function ProfileInfoCard({ icon: Icon, label, value, suffix }) {
  return (
    <div className="rounded-[1.35rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
          <Icon />
        </div>

        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
            {label}
          </p>

          <p className="mt-1 break-words text-sm font-bold leading-6 text-slate-800 dark:text-white">
            {value || "Non spécifié"}
            {value && suffix ? ` ${suffix}` : ""}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProfileInfoCard;